<template>
	<div>
		<StockTrackingAddPalletItems :isPalletItemAddNewActive="isPalletItemAddActive" :data="selectedPallet" />
		<b-row>
			<b-col lg="4">

				<vs-card>
					<form data-vv-scope="headerPallet">
						<!--
						<b-row style="margin-top:8px" v-if="ROLE != 'Company'">
							<b-col cols="4" align-self="center">
								<b-form-group :label="'* ' + $t('Company') + ' :'" label-for="h-first-name">
								</b-form-group>
							</b-col>
							<b-col cols="8">
								<v-select color="danger" v-if="productTraking == ''" v-model="company" :options="company_choices"
									size="small" label="name" autocomplete ref="selectElement" name="company" v-validate="'required'">
								</v-select>
								<v-select color="danger" v-else disabled v-model="company" :options="company_choices" size="small"
									label="name" autocomplete ref="selectElement" name="company" v-validate="'required'">
								</v-select>
								<span class="text-danger text-sm" v-show="errors.has('headerPallet.company')">{{
									errors.first('headerPallet.company')
								}}</span>
							</b-col>
						</b-row>-->
						<b-row style="margin-top:8px">
							<b-col cols="4" align-self="center">
								<b-form-group class="label-cs" :label="'* ' + $t('ProductTrackingName') + ' :'" label-for="h-first-name">
								</b-form-group>
							</b-col>
							<b-col cols="8">
								<vs-input size="small" v-if="productTraking == ''" v-model="productTrackingName" type="text"
									class="w-full" name="productTrackingName" v-validate="'required|min:5'" />
								<vs-input size="small" v-else disabled v-model="productTrackingName" type="text" class="w-full"
									name="productTrackingName" v-validate="'required|min:5'" />
								<span class="text-danger text-sm" v-show="errors.has('headerPallet.productTrackingName')">{{
									errors.first('headerPallet.productTrackingName')
								}}</span>
							</b-col>
						</b-row>

						<b-row style="margin-top:8px">
							<b-col cols="4" align-self="center">
								<b-form-group class="label-cs" :label="'* ' + $t('ProductTrackingDescription') + ' :'"
									label-for="h-first-name">
								</b-form-group>
							</b-col>
							<b-col cols="8">
								<vs-textarea v-if="productTraking == ''" size="small" v-model="productTrackingDescription" type="text"
									class="w-full" name="productTrackingDescription" v-validate="'min:5|required'"></vs-textarea>
								<vs-textarea v-else disabled size="small" v-model="productTrackingDescription" type="text" class="w-full"
									name="productTrackingDescription" v-validate="'min:5|required'"></vs-textarea>
								<span class="text-danger text-sm" v-show="errors.has('headerPallet.productTrackingDescription')">{{
									errors.first('headerPallet.productTrackingDescription')
								}}</span>
							</b-col>
						</b-row>
						<vs-divider />
						<b-row>
							<div class="flex justify-between mb-2">
								<vs-button v-if="productTraking == ''" id="button-with-loading" class="w-full vs-con-loading__container"
									@click="addPalletHeader" style="height: 50px; border-radius: 5px;">
									{{ $t('PalletCreate') }}</vs-button>
								<vs-button v-else disabled id="button-with-loading" class="w-full vs-con-loading__container"
									style="height: 50px; border-radius: 5px;">
									{{ $t('PalletCreate') }}</vs-button>
							</div>
						</b-row>
						<b-row>
							<div class="flex justify-between mb-2">
								<vs-button @click="clearFields" id="button-with-loading" color="danger"
									class="w-full vs-con-loading__container" style="height: 50px; border-radius: 5px;">
									{{ $t('Clear') }}</vs-button>
							</div>
						</b-row>
					</form>
				</vs-card>
			</b-col>

			<b-col lg="8" v-if="!isMobile()">
				<vx-card>
					<div class="demo-inline-spacing">
						<b-form ref="form" @submit.prevent="repeateAgain">
							<b-row>
								<b-col cols="12">
								</b-col>
								<b-col cols="12"> </b-col>
								<b-col cols="12">
									<b-row>
										<b-col cols="2">
											<p style="text-align: center">{{ $t('PalletNo') }}</p>
										</b-col>
										<b-col cols="1">
											<p style="text-align: center">{{ $t('Height') }}</p>
										</b-col>
										<b-col cols="1">
											<p style="text-align: center">{{ $t('Width') }}</p>
										</b-col>
										<b-col cols="1">
											<p style="text-align: center">{{ $t('Depth') }}</p>
										</b-col>
										<b-col cols="1">
											<p style="text-align: center">{{ $t('Weight') }}</p>
										</b-col>
										<b-col cols="1">
											<p style="text-align: center">{{ $t('PalletIsOpen') }}</p>
										</b-col>
										<b-col cols="3">
											<p style="text-align: center">{{ $t('Storehouse') }}</p>
										</b-col>
										<b-col cols="2"><b-button variant="outline-light" size="sm" v-on:click="repeateAgain()">
												<Icon color="#065a82" icon="ic:baseline-plus" width="18" height="20" />
											</b-button> </b-col>
									</b-row>
								</b-col>
								<b-col cols="12">
									<form data-vv-scope="pallets">
										<component :is="scrollbarTag" ref="scroll" class="scroll-area--data-list-add-new" :settings="settings"
											:key="$vs.rtl">
											<b-row v-for="(item, index) in itemsPallets" :id="item.id" :key="item.id" ref="row"
												style="margin-top:5px">
												<!-- Item Name -->
												<b-col cols="2" style="padding-right: 0">
													<b-form-group label-for="cost">
														<vs-input :placeholder="$t('PalletNo')" style="font-size: inherit" size="small"
															v-model="item.palletNo" type="text" class="w-full" :disabled="item.disabled"
															:name="'palletNo_' + item.id" v-validate="'min:5|required'" />
														<span class="text-danger text-sm" v-show="errors.has('pallets.palletNo_' + item.id)">{{
															errors.first('pallets.palletNo_' + item.id)
														}}</span>
													</b-form-group>
												</b-col>
												<b-col cols="1" style="padding-right: 0">
													<b-form-group label-for="cost">
														<vs-input style="font-size: inherit" size="small" v-model="item.height" class="w-full"
															:disabled="item.disabled" :name="'height_' + item.id"
															v-validate="'min_value:11|required'" />
														<span class="text-danger text-sm" v-show="errors.has('pallets.height_' + item.id)">{{
															errors.first('pallets.height_' + item.id)
														}}</span>
													</b-form-group>
												</b-col>
												<b-col cols="1" style="padding-right: 0">
													<b-form-group label-for="cost">
														<vs-input style="font-size: inherit" size="small" v-model="item.width"
															v-validate="'min_value:11|required'" class="w-full" :disabled="item.disabled"
															:name="'width_' + item.id" />
														<span class="text-danger text-sm" v-show="errors.has('pallets.width_' + item.id)">{{
															errors.first('pallets.width_' + item.id)
														}}</span>
													</b-form-group>
												</b-col>
												<b-col cols="1" style="padding-right: 0">
													<b-form-group label-for="cost">
														<vs-input style="font-size: inherit" size="small" v-model="item.depth"
															v-validate="'min_value:11|required'" class="w-full" :disabled="item.disabled"
															:name="'depth_' + item.id" />
														<span class="text-danger text-sm" v-show="errors.has('pallets.depth_' + item.id)">{{
															errors.first('pallets.depth_' + item.id)
														}}</span>
													</b-form-group>
												</b-col>
												<b-col cols="1" style="padding-right: 0">
													<b-form-group label-for="cost">
														<vs-input style="font-size: inherit" size="small" v-model="item.weight"
															v-validate="'min_value:11|required'" class="w-full" :disabled="item.disabled"
															:name="'weight_' + item.id" />
														<span class="text-danger text-sm" v-show="errors.has('pallets.weight_' + item.id)">{{
															errors.first('pallets.weight_' + item.id)
														}}</span>
													</b-form-group>
												</b-col>
												<b-col cols="1" style="padding-right: 0; text-align: -webkit-center;" align-self="start">
													<vs-checkbox style="width: 25px;" v-model="item.palletIsOpen" :disabled="item.disabled"
														name="palletIsOpen"></vs-checkbox>
												</b-col>
												<b-col cols="3" style="padding-right: 0; text-align: -webkit-center;" align-self="start">


													<vue-autosuggest :name="'storehouse_' + item.id" v-validate="'required'"
														v-model="item.storehouse" style="width: 100%" @click="storehouseIndex = index"
														:suggestions="storehouse_choices" :get-suggestion-value="getSuggestionValue" :input-props="{
															disabled: item.disabled,
															id: 'autosuggest__input',
															class: 'form-control'
														}" @input="storehouseInp = item.storehouse; getStorehpuseListFitered()">
														<template slot-scope="{ suggestion }">
															<div class="d-flex align-items-center my-suggestion-item">
																<div class="detail ml-50 my-suggestion-item">
																	<b-card-text class="mb-0">
																		{{ suggestion.item.CompanyName }} /
																		{{ suggestion.item.DepotName.trim() }} /
																		{{ suggestion.item.DepotNo }}
																	</b-card-text>
																</div>
															</div>
														</template>

													</vue-autosuggest>
													<span class="text-danger text-sm" v-show="errors.has('pallets.storehouse_' + item.id)">{{
														errors.first('pallets.storehouse_' + item.id)
													}}</span>
												</b-col>
												<b-col v-if="!isMobile()" style="padding-right: 0;" cols="2" class="mb-50">
													<b-row v-if="item.disabled == false">
														<b-col style="padding: 0;max-width: max-content;">
															<b-button style="max-width: max-content;" v-if="productTraking == ''" disabled
																variant="outline-light" size="sm" v-on:click="addPallets(index)">
																<Icon color="#28c76f" icon="ic:baseline-save-all" width="20" height="20" />
															</b-button>
															<b-button style="max-width: max-content;" v-else variant="outline-light" size="sm"
																v-on:click="addPallets(index)">
																<Icon color="#28c76f" icon="ic:baseline-save-all" width="20" height="20" />
															</b-button>

														</b-col>
														<b-col style="padding: 0; max-width: max-content;">
															<b-button v-if="productTraking == ''" disabled variant="outline-light" size="sm"
																v-on:click="deletePallets(index)">
																<Icon color="#EA5455" icon="ic:baseline-remove-circle" width="18" height="20" />
															</b-button>
															<b-button v-else variant="outline-light" size="sm" v-on:click="deletePallets(index)">
																<Icon color="#EA5455" icon="ic:baseline-remove-circle" width="18" height="20" />
															</b-button>
														</b-col>
													</b-row>
													<b-row v-else>

														<b-col style="padding: 0; max-width: max-content;">
															<b-button variant="outline-light" size="sm" v-on:click="updatePallets(index)">
																<Icon color="#7367F0" icon="material-symbols:select-check-box" width="20" height="20" />
															</b-button>
														</b-col>
														<b-col style="padding: 0; max-width: max-content;">
															<b-button v-if="productTraking == ''" disabled variant="outline-light" size="sm"
																v-on:click="deletePallets(index)">
																<Icon color="#EA5455" icon="ic:baseline-remove-circle" width="18" height="20" />
															</b-button>
															<b-button v-else variant="outline-light" size="sm" v-on:click="deletePallets(index)">
																<Icon color="#EA5455" icon="ic:baseline-remove-circle" width="18" height="20" />
															</b-button>
														</b-col>
														<!--
														<b-col style="padding: 0; max-width: max-content;">
															<b-button v-if="item.palletIsOpen == true" variant="outline-light" size="sm"
																v-on:click="addPalletsItems(index)">
																<Icon color="#FF9F43" icon="carbon:product" width="20" height="20" />
															</b-button>
															<b-button v-else disabled variant="outline-light" size="sm"
																v-on:click="addPalletsItems(index)">
																<Icon color="#FF9F43" icon="carbon:product" width="20" height="20" />
															</b-button>

														</b-col>-->
														<b-col style="padding: 0; max-width: max-content;">
															<feather-icon v-if="item.palletIsOpen == true" icon="ShoppingCartIcon"
																class="cursor-pointer ml-1 mr-3 mt-1" style="width: 18px;"
																:badge="item.palletItems.length" v-on:click="addPalletsItems(index)" />
														</b-col>
													</b-row>
												</b-col>
												<b-col v-else style="padding-right: 0;" cols="2" class="mb-50">
													<b-row v-if="item.disabled == false">
														<b-col style="padding: 0">
															<b-button v-if="productTraking == ''" disabled variant="outline-light" size="sm"
																v-on:click="addPallets(index)">
																<Icon color="#28c76f" icon="ic:baseline-save-all" width="20" height="20" />
															</b-button>
															<b-button v-else variant="outline-light" size="sm" v-on:click="addPallets(index)">
																<Icon color="#28c76f" icon="ic:baseline-save-all" width="20" height="20" />
															</b-button>
															<b-col style="padding: 0; max-width: max-content;">
																<b-button v-if="productTraking == ''" disabled variant="outline-light" size="sm"
																	v-on:click="deletePallets(index)">
																	<Icon color="#EA5455" icon="ic:baseline-remove-circle" width="18" height="20" />
																</b-button>
																<b-button v-else variant="outline-light" size="sm" v-on:click="deletePallets(index)">
																	<Icon color="#EA5455" icon="ic:baseline-remove-circle" width="18" height="20" />
																</b-button>
															</b-col>
														</b-col>
													</b-row>
													<b-row v-else>

														<b-col style="padding: 0; max-width: max-content;">
															<b-button variant="outline-light" size="sm" v-on:click="updatePallets(index)">
																<Icon color="#7367F0" icon="material-symbols:select-check-box" width="18" height="20" />
															</b-button>
														</b-col>
														<b-col style="padding: 0; max-width: max-content;">
															<b-button v-if="item.palletIsOpen == true" variant="outline-light" size="sm"
																v-on:click="addPalletsItems(index)">
																<Icon color="#FF9F43" icon="carbon:product" width="20" height="20" />
															</b-button>
															<b-button v-else disabled variant="outline-light" size="sm"
																v-on:click="addPalletsItems(index)">
																<Icon color="#FF9F43" icon="carbon:product" width="20" height="20" />
															</b-button>

														</b-col>
													</b-row>
												</b-col>
												<b-col cols="12" style="height: 5px"> </b-col>
											</b-row>
										</component>
									</form>
								</b-col>
							</b-row>
							<b-row vs-justify="flex-end">
								<b-button @click="savePallets()" style="background-color: #7baf7f;     border-color: #7baf7f;">
									<Icon icon="material-symbols:save-as" width="20" height="20" v-b-tooltip.hover.bottom="$t('Save')" />
									{{ $t('Save') }}
								</b-button>
							</b-row>
						</b-form>
					</div>
				</vx-card>
			</b-col>
			<b-col lg="8" v-else>
				<vx-card>
					<div class="demo-inline-spacing">
						<b-form ref="form" @submit.prevent="repeateAgain">
							<b-row><!--
								<b-col cols="12">
								</b-col>
								<b-col cols="12"> </b-col>
								<b-col cols="12">
									<b-row>
										<b-col cols="2">
											<p style="text-align: center">{{ $t('PalletNo') }}</p>
										</b-col>
										<b-col cols="1">
											<p style="text-align: center">{{ $t('Height') }}</p>
										</b-col>
										<b-col cols="1">
											<p style="text-align: center">{{ $t('Width') }}</p>
										</b-col>
										<b-col cols="1">
											<p style="text-align: center">{{ $t('Depth') }}</p>
										</b-col>
										<b-col cols="1">
											<p style="text-align: center">{{ $t('Weight') }}</p>
										</b-col>
										<b-col cols="1">
											<p style="text-align: center">{{ $t('PalletIsOpen') }}</p>
										</b-col>
										<b-col cols="3">
											<p style="text-align: center">{{ $t('Storehouse') }}</p>
										</b-col>
										<b-col cols="2"><b-button variant="outline-light" size="sm" v-on:click="repeateAgain()">
												<Icon color="#065a82" icon="ic:baseline-plus" width="18" height="20" />
											</b-button> </b-col>
									</b-row>
								</b-col>-->
								<b-col cols="12">
									<form data-vv-scope="pallets">
										<component :is="scrollbarTag" ref="scroll" class="scroll-area--data-list-add-new-mobile"
											:settings="settings" :key="$vs.rtl">
											<b-row v-for="(item, index) in itemsPallets" :id="item.id" :key="item.id" ref="row"
												style="margin-top:5px">
												<!-- Item Name -->
												<b-col cols="11" style="padding-right: 0">
													<b-row>
														<b-col cols="4" align-self="center">
															<b-form-group class="label-cs" :label="$t('PalletNo')" label-for="h-first-name">
															</b-form-group>
														</b-col>
														<b-col>
															<b-form-group label-for="cost">
																<vs-input :placeholder="$t('PalletNo')" style="font-size: inherit" size="small"
																	v-model="item.palletNo" type="text" class="w-full" :disabled="item.disabled"
																	:name="'palletNo_' + item.id" v-validate="'min:5|required'" />
																<span class="text-danger text-sm" v-show="errors.has('pallets.palletNo_' + item.id)">{{
																	errors.first('pallets.palletNo_' + item.id)
																}}</span>
															</b-form-group>
														</b-col>
													</b-row>

												</b-col>
												<b-col cols="11" style="padding-right: 0; margin-top:5px ">
													<b-row>
														<b-col cols="4" align-self="center">
															<b-form-group class="label-cs" :label="$t('Height')" label-for="h-first-name">
															</b-form-group>
														</b-col>
														<b-col>
															<b-form-group label-for="cost">
																<vs-input style="font-size: inherit" size="small" v-model="item.height" class="w-full"
																	:disabled="item.disabled" :name="'height_' + item.id"
																	v-validate="'min_value:11|required'" />
																<span class="text-danger text-sm" v-show="errors.has('pallets.height_' + item.id)">{{
																	errors.first('pallets.height_' + item.id)
																}}</span>
															</b-form-group>
														</b-col>
													</b-row>

												</b-col>
												<b-col cols="11" style="padding-right: 0; margin-top:5px">
													<b-row>
														<b-col cols="4" align-self="center">
															<b-form-group class="label-cs" :label="$t('Width')" label-for="h-first-name">
															</b-form-group>
														</b-col>
														<b-col>
															<b-form-group label-for="cost">
																<vs-input style="font-size: inherit" size="small" v-model="item.width"
																	v-validate="'min_value:11|required'" class="w-full" :disabled="item.disabled"
																	:name="'width_' + item.id" />
																<span class="text-danger text-sm" v-show="errors.has('pallets.width_' + item.id)">{{
																	errors.first('pallets.width_' + item.id)
																}}</span>
															</b-form-group>
														</b-col>
													</b-row>
												</b-col>
												<b-col cols="11" style="padding-right: 0; margin-top:5px">
													<b-row>
														<b-col cols="4" align-self="center">
															<b-form-group class="label-cs" :label="$t('Depth')" label-for="h-first-name">
															</b-form-group>
														</b-col>
														<b-col>
															<b-form-group label-for="cost">
																<vs-input style="font-size: inherit" size="small" v-model="item.depth"
																	v-validate="'min_value:11|required'" class="w-full" :disabled="item.disabled"
																	:name="'depth_' + item.id" />
																<span class="text-danger text-sm" v-show="errors.has('pallets.depth_' + item.id)">{{
																	errors.first('pallets.depth_' + item.id)
																}}</span>
															</b-form-group>
														</b-col>
													</b-row>

												</b-col>
												<b-col cols="11" style="padding-right: 0; margin-top:5px">
													<b-row>
														<b-col cols="4" align-self="center">
															<b-form-group class="label-cs" :label="$t('Weight')" label-for="h-first-name">
															</b-form-group>
														</b-col>
														<b-col>
															<b-form-group label-for="cost">
																<vs-input style="font-size: inherit" size="small" v-model="item.weight"
																	v-validate="'min_value:11|required'" class="w-full" :disabled="item.disabled"
																	:name="'weight_' + item.id" />
																<span class="text-danger text-sm" v-show="errors.has('pallets.weight_' + item.id)">{{
																	errors.first('pallets.weight_' + item.id)
																}}</span>
															</b-form-group>
														</b-col>
													</b-row>

												</b-col>
												<b-col cols="11" style="padding-right: 0;  margin-top:5px" align-self="start">
													<b-row>
														<b-col cols="4" align-self="center">
															<b-form-group class="label-cs" :label="$t('PalletIsOpen')" label-for="h-first-name">
															</b-form-group>
														</b-col>
														<b-col>
															<vs-checkbox style="width: 25px;" v-model="item.palletIsOpen" :disabled="item.disabled"
																name="palletIsOpen"></vs-checkbox>
														</b-col>
													</b-row>

												</b-col>
												<b-col cols="11" style="padding-right: 0; margin-top:5px" align-self="start">
													<b-row>
														<b-col cols="4" align-self="center">
															<b-form-group class="label-cs" :label="$t('Storehouse')" label-for="h-first-name">
															</b-form-group>
														</b-col>
														<b-col>
															<vue-autosuggest :name="'storehouse_' + item.id" v-validate="'required'"
																v-model="item.storehouse" style="width: 100%" @click="storehouseIndex = index"
																:suggestions="storehouse_choices" :get-suggestion-value="getSuggestionValue" :input-props="{
																	disabled: item.disabled,
																	id: 'autosuggest__input',
																	class: 'form-control'
																}" @input="storehouseInp = item.storehouse; getStorehpuseListFitered()">
																<template slot-scope="{ suggestion }">
																	<div class="d-flex align-items-center my-suggestion-item">
																		<div class="detail ml-50 my-suggestion-item">
																			<b-card-text class="mb-0">
																				{{ suggestion.item.CompanyName }} /
																				{{ suggestion.item.DepotName.trim() }} /
																				{{ suggestion.item.DepotNo }}
																			</b-card-text>
																		</div>
																	</div>
																</template>
															</vue-autosuggest>
															<span class="text-danger text-sm" v-show="errors.has('pallets.storehouse_' + item.id)">{{
																errors.first('pallets.storehouse_' + item.id)
															}}</span>
														</b-col>
													</b-row>

												</b-col>

												<b-col style="padding-right: 0;" cols="12" class="mb-50">
													<b-row v-if="item.disabled == false">
														<b-col style="padding: 0">
															<b-button v-if="productTraking == ''" disabled variant="outline-light" size="sm"
																v-on:click="addPallets(index)">
																<Icon color="#28c76f" icon="ic:baseline-save-all" width="20" height="20" />
															</b-button>
															<b-button v-else variant="outline-light" size="sm" v-on:click="addPallets(index)">
																<Icon color="#28c76f" icon="ic:baseline-save-all" width="20" height="20" />
															</b-button>

														</b-col>
														<b-col style="padding: 0; ">
															<b-button v-if="productTraking == ''" disabled variant="outline-light" size="sm"
																v-on:click="deletePallets(index)">
																<Icon color="#EA5455" icon="ic:baseline-remove-circle" width="18" height="20" />
															</b-button>
															<b-button v-else variant="outline-light" size="sm" v-on:click="deletePallets(index)">
																<Icon color="#EA5455" icon="ic:baseline-remove-circle" width="18" height="20" />
															</b-button>
														</b-col>
													</b-row>
													<b-row v-else>

														<b-col style="padding: 0; max-width: max-content;">
															<b-button variant="outline-light" size="sm" v-on:click="updatePallets(index)">
																<Icon color="#7367F0" icon="material-symbols:select-check-box" width="18" height="20" />
															</b-button>
														</b-col>
														<b-col style="padding: 0; max-width: max-content;">
															<b-button v-if="item.palletIsOpen == true" variant="outline-light" size="sm"
																v-on:click="addPalletsItems(index)">
																<Icon color="#FF9F43" icon="carbon:product" width="20" height="20" />
															</b-button>
															<b-button v-else disabled variant="outline-light" size="sm"
																v-on:click="addPalletsItems(index)">
																<Icon color="#FF9F43" icon="carbon:product" width="20" height="20" />
															</b-button>

														</b-col>
													</b-row>
												</b-col>
												<b-col cols="12" style="height: 5px"> </b-col>
											</b-row>
										</component>
									</form>
								</b-col>
							</b-row>
							<b-row vs-justify="flex-end">
								<b-button @click="savePallets()" style="background-color: #7baf7f;     border-color: #7baf7f;">
									<Icon icon="material-symbols:save-as" width="20" height="20" v-b-tooltip.hover.bottom="$t('Save')" />
									{{ $t('Save') }}
								</b-button>
							</b-row>
						</b-form>
					</div>
				</vx-card>
			</b-col>
		</b-row>
	</div>
</template>
<script>
import StockTrackingAddPalletItems from "./StockTrackingAddPalletItems.vue";
import { Validator } from "vee-validate";
import { Icon } from "@iconify/vue2";
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from "vue-select";
import { isMobile } from "mobile-device-detect";
export default {
	props: {
		data: {
			default: () => { }
		},
	},
	watch: {
		data() {
			this.productTrackingName = this.data.ProductTrackingName
			this.productTrackingDescription = this.data.ProductTrackingDescription
			this.productTraking = {
				productTrackingName: this.productTrackingName,
				productTrackingDescription: this.productTrackingDescription,
				productTrackingType: null,
				productTrackingNo: null,
				isTracking: false,
				companyId: this.ROLE == "Company" ? this.$store.state.AppActiveUser.companyid : this.company.value,
				pallets: []
			}
			this.getStockTrackingList();

		}
	},
	data() {
		return {
			storehouseList: [],
			ROLE: this.$store.state.AppActiveUser.ROLE,
			addPalletItemIndex: "",
			storehouseIndex: "",
			storehouseInp: "",
			selectedPallet: [],
			isPalletItemAddActive: false,
			productTraking: "",
			settings: { // perfectscrollbar settings
				maxScrollbarLength: 60,
				wheelSpeed: .60
			},
			isMobile: function () {
				return isMobile;
			},
			company: "",
			itemsPallets: [
				{
					id: 1,
					palletNo: "",
					height: 11,
					width: 11,
					depth: 11,
					weight: 11,
					palletIsOpen: false,
					storehouse: "",
					storehouseDetail: "",
					disabled: false,
					updated: false,
					palletId: "",
					palletItems: [],
					palletJobDone: false,
					depotId: "",
					productTrackingId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
				}
			],
			storehouse_choices: [],
			company_choices: [],
			type_choices: [],
			customerListOption: [],
			productTrackingDescription: "",
			productTrackingType: "",
			productTrackingNo: "",
			productTrackingName: "",
		}
	},
	components: { StockTrackingAddPalletItems, Icon, VuePerfectScrollbar, vSelect },
	computed: {
		storehouseForCompany: {
			get() {
				return this.$store.state.storehouse.StorehouseForCompany
			},
			set(val) {
				if (!val) {

				}
			}

		},
		scrollbarTag() { return this.$store.getters.scrollbarTag },
		storehousedata: {
			get() {
				this.storehouse_choices =
					[
						{
							data: this.$store.state.storehouse.Storehouse.filter(option => {
								return (
									option.DepotName.toLowerCase().indexOf(this.storehouseInp) >
									-1
								);
							})
						}
					];

				return this.$store.state.storehouse.Storehouse
			},
			set(val) {
				if (!val) {
				}
			}
		},
		companydata: {
			get() {
				return this.$store.state.customer.Customer
			},
			set(val) {
				if (!val) {
				}
			}
		}
	},
	methods: {
		getStockTrackingList() {
			const vs = this.$vs;
			this.itemsPallets = []
			this.$store.dispatch("stockTracking/listStockTrackingDetailsList", this.data.ProductTrackingId).then(response => {
				// let costumerList = JSON.parse(response.json);
				if (response.success == true) {
					let stocktrackingDetailList = this.$store.state.stockTracking.StockTrackingDetails

					stocktrackingDetailList.Pallets.forEach((val, index) => {
						this.productTraking.pallets.push(val)
						this.itemsPallets.push(
							{
								id: index + 1,
								palletNo: val.PalletNo,
								height: val.Height,
								width: val.Width,
								depth: val.Depth,
								weight: val.Weight,
								palletIsOpen: val.PalletIsOpen,
								storehouse: val.Storehouse,
								storehouseDetail: val.StorehouseDetail,
								disabled: true,
								updated: false,
								palletId: val.PalletId,
								depotId: "",
								palletItems: [],
								palletJobDone: val.PalletJobDone,
								productTrackingId: val.ProductTrackingId,
							}
						)
						if (val.PalletIsOpen == true) {
							val.PalletItems.forEach((value, ind) => {
								console.log(value)
								console.log(this.itemsPallets)

								console.log(this.itemsPallets[index])
								this.itemsPallets[index].palletItems.push(
									{
										id: ind,
										palletNo: value.PalletNo,
										stockCode: value.StockCode,
										quantity: value.Quantity,
										barcode: value.Barcode,
										disabled: true,
										palletId: value.PalletItemId
									}
								)

							});
						}
					});
					console.log(this.productTraking)
					console.log(this.itemsPallets)
				} else
					console.log(response.statusText)
				/*	vs.notify({
						text: response.statusText,
						iconPack: "feather",
						icon: "icon-alert-circle",
						color: "danger",
						position: "top-center"
					});*/
			});
		},
		initValues() {
			this.productTrackingDescription = ""
			this.productTrackingName = "";
			this.productTraking = ""
			this.itemsPallets = [
				{
					id: 1,
					palletNo: "",
					height: 11,
					width: 11,
					depth: 11,
					weight: 11,
					palletIsOpen: false,
					storehouse: "",
					storehouseDetail: "",
					disabled: false,
					updated: false,
					palletId: "",
					depotId: "",
					palletItems: [],
					palletJobDone: false,
					productTrackingId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
				}
			];
		},
		savePallets() {
			const vs = this.$vs;
			this.productTraking.pallets = this.itemsPallets.filter(x => {
				return x.disabled == true
			});
			const obj = this.productTraking
			console.log(obj)
			console.log(JSON.stringify(obj))
			this.$store.dispatch('stockTracking/addStockTracking', obj).then(response => {

				if (response.status == 200) {
					vs.notify({

						text: response.data.message,
						iconPack: "feather",
						icon: "icon-alert-circle",
						color: "success",
						position: "top-center"
					});

					this.initValues()
				} else {
					vs.notify({
						text: response.data.message.toString(),
						iconPack: "feather",
						icon: "icon-alert-circle",
						color: "danger",
						position: "top-center",
					});
				}
			})
				.catch(error => {
					return new Promise((resolve, reject) => {
						resolve(false);
					});
				});
		},
		submitPaletItems(data) {
			/*	if (data.palletItems.length > 0)
					this.toggleDataSidebarPalletItem(false)
				else this.toggleDataSidebarPalletItem(true)*/

			this.toggleDataSidebarPalletItem(false)
		},
		getStorehpuseListFitered() {
			this.storehouse_choices =
				[
					{
						data: this.storehouseList.filter(option => {
							return (
								option.DepotName.toLowerCase().indexOf(this.storehouseInp) >
								-1 || option.DepotNo.toLowerCase().indexOf(this.storehouseInp) >
								-1 || option.CompanyName.toLowerCase().indexOf(this.storehouseInp) >
								-1
							);
						})
					}
				];
		},
		getSuggestionValue(suggestion) {
			this.itemsPallets[this.storehouseIndex].storehouse = suggestion.item.DepotName + " - " + suggestion.item.DepotNo
			this.itemsPallets[this.storehouseIndex].depotId = suggestion.item.DepotId

			this.itemsPallets[this.storehouseIndex].storehouseDetail = suggestion.item
			console.log(this.itemsPallets)
			return suggestion.item.DepotName + " - " + suggestion.item.DepotNo
		},
		toggleDataSidebarPalletItem(val = false) {
			this.isPalletItemAddActive = val
		},
		addPalletsItems(index) {
			this.addPalletItemIndex = index
			this.selectedPallet = this.itemsPallets[index]
			this.isPalletItemAddActive = true
		},
		updatePallets(index) {
			this.itemsPallets[index].disabled = false;
			this.itemsPallets[index].updated = true;
			this.itemsPallets.forEach((val, ind) => {
				if (val.disabled == false && val.updated == false) this.deletePallets(ind)
			});
		},
		deletePallets(index) {
			this.itemsPallets.splice(index, 1)
			this.productTraking.pallets = this.itemsPallets.filter(x => {
				return x.disabled == true
			});
		},
		clearFields() {
			this.itemsPallets = [{
				id: 1,
				palletNo: "",
				height: 11,
				width: 11,
				depth: 11,
				weight: 11,
				palletIsOpen: false,
				storehouse: "",
				depotId: "",
				storehouseDetail: "",
				disabled: false,
				updated: false,
				palletId: "",
				palletItems: [],
				palletJobDone: false,
				productTrackingId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
			}];
			this.productTraking = "";
			this.productTrackingDescription = "";
			this.productTrackingType = "";
			this.productTrackingNo = "";
			this.productTrackingName = "";
			this.company = "";
		},
		repeateAgain() {
			const vs = this.$vs;
			let setId = 0
			var itemLocate = this.itemsPallets[this.itemsPallets.length - 1];
			if (this.itemsPallets.length == 0) setId = 0
			else setId = itemLocate.id + 1
			this.itemsPallets.push({
				id: setId,
				disabled: false,
				updated: false,
				palletNo: "",
				height: 11,
				width: 11,
				depth: 11,
				weight: 11,
				palletIsOpen: false,
				storehouse: "",
				storehouseDetail: "",
				depotId: "",
				palletItems: [],
				palletJobDone: false,
				productTrackingId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
			});
			this.productTraking.pallets = this.itemsPallets.filter(x => {
				return x.disabled == true
			});

		},
		checkPallets(index, response) {
			if (this.itemsPallets.length == index) {
				return response
			}
			else {
				if (this.itemsPallets[index].palletNo == "" && this.itemsPallets[index].updated == false && this.itemsPallets[index].disabled == false) {
					response += "false"
					this.itemsPallets.splice(index, 1)
					this.checkPallets(index, response)
				} else if (this.itemsPallets[index].palletNo != "" && this.itemsPallets[index].updated == false && this.itemsPallets[index].disabled == false) {
					response += "false"
					this.checkPallets(index + 1, response)
				} else {
					this.checkPallets(index + 1, response)
				}
				return response
			}
		},
		addPallets(index) {
			const vs = this.$vs;
			this.$validator.validateAll("pallets").then(result => {
				if (result) {
					this.productTraking.pallets = this.itemsPallets.filter(x => {
						return x.disabled == true
					});
					this.itemsPallets[index].disabled = true
					//	this.itemsPallets[index].id = true
					if (this.itemsPallets[index].palletIsOpen == true) {
						this.selectedPallet = this.itemsPallets[index]
						this.isPalletItemAddActive = true
					}
					this.repeateAgain();

				}
				else {
					vs.notify({
						text: this.$t('Validate'),
						iconPack: "feather",
						icon: "icon-alert-circle",
						color: "warning",
						position: "top-center"
					});
				}
			})

		},
		getStocktrackingTypeList() {
			this.type_choices = Object.values(this.$store.state.stockTracking.StocktrackingType);
		},
		addPalletHeader() {
			const vs = this.$vs;
			this.$validator.validateAll("headerPallet").then(result => {
				if (result) {
					this.productTraking = {
						productTrackingName: this.productTrackingName,
						productTrackingDescription: this.productTrackingDescription,
						productTrackingType: null,
						productTrackingNo: null,
						isTracking: false,
						companyId: this.ROLE == "Company" ? this.$store.state.AppActiveUser.companyid : this.company.value,
						pallets: []
					}
				}
				else {
					vs.notify({
						text: this.$t('Validate'),
						iconPack: "feather",
						icon: "icon-alert-circle",
						color: "warning",
						position: "top-center"
					});
				}
			})

		},
		getCompanyList() {
			this.companydata.forEach((val, index) => {
				this.company_choices.push({ value: val.CompanyId, name: val.CompanyName })
			});
		},

	},
	created() {
		console.log(this.storehouseForCompany)
		if (this.ROLE == "Company") this.storehouseList = this.storehouseForCompany
		else this.storehouseList = this.storehousedata

		this.storehouse_choices =
			[
				{
					data: this.storehouseList.filter(option => {
						return (
							option.DepotName.toLowerCase().indexOf(this.storehouseInp) >
							-1
						);
					})
				}
			];
		this.getStocktrackingTypeList();
		this.getCompanyList();
		const dict = {
			custom: {
				weight_1: {
					min_value: "min 11"
				},
				company: {
					required: this.$t('customerRequired'),
					alpha: this.$t('customerRequired')
				},
				productTrackingName: {
					required: this.$t('ProductTrackingNameRequired'),
					alpha: this.$t('ProductTrackingNameRequired'),
					min: this.$t('MinRequired5'),
				},
				productTrackingNo: {
					required: this.$t('ProductTrackingNoNameRequired'),
					alpha: this.$t('ProductTrackingNoNameRequired')
				}, productTrackingType: {
					required: this.$t('ProductTrackingTypeNameRequired'),
					alpha: this.$t('ProductTrackingTypeNameRequired')
				},
				productTrackingDescription: {
					required: this.$t('ProductTrackingDescriptionNameRequired'),
					alpha: this.$t('ProductTrackingDescriptionNameRequired'),
					min: this.$t('MinRequired5'),

				}
			}
		};
		Validator.localize("en", dict);
	},
	mounted() {
		//tables global olarak tanımlanıyor
		this.$root.$on("closePalletItemsPopup", (val) => {
			this.toggleDataSidebarPalletItem(val);
		});
		this.$root.$on("submitPaletItems", (data) => {
			this.submitPaletItems(data);
		});

	},
	beforeDestroy() {
		this.$root.$off("closePalletItemsPopup");
		this.$root.$off("submitPaletItems");

	},
}
</script>
<style lang="scss"  >
.label-cs {
	color: black;
	font-size: small;
}

.autosuggest-container {
	display: flex;
	justify-content: center;
	width: 280px;
}

#autosuggest {
	width: 100%;
	display: block;
}

.autosuggest__results-item--highlighted {
	background-color: rgba(51, 217, 178, 0.2);
}



.autosuggest-container {
	display: flex;
	justify-content: center;
	width: 280px;
}

#autosuggest {
	width: 100%;
	display: block;
}

.autosuggest__results-item--highlighted {
	background-color: rgba(51, 217, 178, 0.2);
}

.scroll-area--data-list-add-new {
	// height: calc(var(--vh, 1vh) * 100 - 4.3rem);
	height: calc(var(--vh, 1vh) * 100 - 16px - 100px - 180px);

	&:not(.ps) {
		overflow-y: auto;
	}
}

.scroll-area--data-list-add-new-mobile {
	height: calc(var(--vh, 1vh) * 60 - 16px - 100px - 100px);

	&:not(.ps) {
		overflow-y: auto;
	}
}

[dir="ltr"] .autosuggest__results,
[dir="rtl"] .autosuggest__results {
	z-index: 1111111111111;
}

[dir] #autosuggest__input {
	padding: 5px !important;
	font-size: 12px;
}

#autosuggest__input {
	outline: none;
	position: relative;
	display: block;
	padding: 10px;
	width: 100%;
	box-sizing: border-box;
	-webkit-box-sizing: border-box;
	-moz-box-sizing: border-box;
}

#autosuggest__input.autosuggest__input-open {
	border-bottom-left-radius: 0;
	border-bottom-right-radius: 0;
}

.autosuggest__results-container {
	position: relative;
	width: 100%;
	z-index: 11111;
}

[dir] .autosuggest__results .autosuggest__results-item {
	padding: 7px !important;
}

[dir] .card-text:last-child {
	color: black;
	font-weight: 500;
}

.autosuggest__results {
	font-weight: 300;
	margin: 0;
	position: absolute;
	z-index: 1000000111111111111111111;
	width: 100%;
	border: 1px solid #e0e0e0;
	border-bottom-left-radius: 4px;
	border-bottom-right-radius: 4px;
	background: white;
	padding: 0px;
	max-height: 200px;
	overflow-y: scroll;
}

.autosuggest__results ul {
	list-style: none;
	padding-left: 0;
	margin: 0;
}

.autosuggest__results .autosuggest__results-item {
	cursor: pointer;
	padding: 15px;
}

#autosuggest ul:nth-child(1)>.autosuggest__results-before {
	border-top: none;
}

.autosuggest__results .autosuggest__results-before {
	color: gray;
	font-size: 11px;
	margin-left: 0;
	padding: 15px 13px 5px;
	border-top: 1px solid lightgray;
}

.autosuggest__results .autosuggest__results-item:active,
.autosuggest__results .autosuggest__results-item:hover,
.autosuggest__results .autosuggest__results-item:focus,
.autosuggest__results .autosuggest__results-item.autosuggest__results-item--highlighted {
	background-color: #f6f6f6;
}
</style>